import { getEnvironment } from '../../environment'
import CookieHelper from '../../utils/CookieHelper'
import { BrowserUtils, QueryUtils } from '../../utils/siteUtils'

/**
 * Rules defination here: https://coxautoinc.sharepoint.com/:x:/r/sites/ConsumerPortfolioAnalyticsTagging/_layouts/15/Doc.aspx?sourcedoc=%7B8D12A495-266D-45BE-9324-54C3A6EB0728%7D&file=InfoTrust%20%2B%20CAI%20Tagging%20Specs%20-%20ICO_DAT%2010.26.21.xlsx&action=default&mobileredirect=true&cid=0a77cb77-6c6b-40a0-9c31-ae7d3487dfd6
 */
let firstPageReadyFired = false
const if_pageReady = dataLayer => {
  setTimeout(
    dataLayer => {
      console.log('IF PageReady', dataLayer)
      try {
        if (!window.dataLayer) window.dataLayer = []
        window.dataLayer.push(
          trimObject({
            event: 'page_data',
            common: {
              dataLayerVersion: '1',
              application: {
                businessUnit: dataLayer.pageInfo.experience === 'atc' ? 'autotrader' : 'kelley blue book',
                name: getOperatingSystem(),
                version: '1.0.0',
                environment: getEnvironment().environmentName || 'local'
              },
              user: trimObject({
                zipCode: dataLayer.location.zip && dataLayer.location.zip + ''
              }),
              page: trimObject({
                detailPageName: dataLayer.pageInfo.detailPageName,
                experimentId: dataLayer.pageInfo.experimentId,
                leadTrackingId: dataLayer.offer.offerId,
                pageType: dataLayer.pageInfo.pageName,
                pixAllABC: dataLayer.cookies.pxa_id,
                pixallPageInstanceId: dataLayer.session.pageInstance,
                pixAllPXAId: CookieHelper.get('abc') || CookieHelper.get('pxa_id') || '',
                siteSection: 'ico',
                ...getPageInfo(dataLayer.pageInfo, dataLayer.offer)
              })
            },
            ...(dataLayer.vehicle
              ? {
                  vehicle: getVehiclePageData(dataLayer)
                }
              : { vehicle: undefined }),
            ico: trimObject({
              entryPoint: dataLayer.cookies.lnx,
              offerCode: dataLayer.offer.offerCode,
              offerId: dataLayer.offer.offerId,
              optionToSell: dataLayer.offer.optIn,
              path: dataLayer.pageInfo.path
            }),
            ...(dataLayer.replacementVehicle && dataLayer.replacementVehicle.types
              ? {
                  voi: trimObject({
                    catalog: dataLayer.replacementVehicle.types ? dataLayer.pageInfo.experience : undefined,
                    condition: dataLayer.replacementVehicle.types ? dataLayer.replacementVehicle.types.join('::') : undefined,
                    entry: 'ymm',
                    makeId: dataLayer.replacementVehicle.makeId && dataLayer.replacementVehicle.makeId + '',
                    makeName: dataLayer.replacementVehicle.make,
                    modelId: dataLayer.replacementVehicle.modelId && dataLayer.replacementVehicle.modelId + '',
                    modelName: dataLayer.replacementVehicle.model,
                    trimId: dataLayer.replacementVehicle.trimId && dataLayer.replacementVehicle.trimId + '',
                    trimName: dataLayer.replacementVehicle.trimName,
                    vehicleId: dataLayer.replacementVehicle.vehicleId && dataLayer.replacementVehicle.vehicleId + '',
                    year: dataLayer.replacementVehicle.minYear && dataLayer.replacementVehicle.maxYear && `${dataLayer.replacementVehicle.minYear}-${dataLayer.replacementVehicle.maxYear}`
                  })
                }
              : { voi: undefined }),
            ...(dataLayer.consumerInsights
              ? {
                  consumerInsights: trimObject({
                    apiTrackingId: dataLayer.session.visitorId,
                    preferredMileage: dataLayer.consumerInsights.preferredMileage && dataLayer.consumerInsights.preferredMileage + '',
                    preferredMake: dataLayer.preferredMake,
                    preferredModel: dataLayer.preferredModel,
                    preferredBodyStyle: dataLayer.preferredBodyStyle,
                    preferredPrice: dataLayer.consumerInsights.preferredPrice && dataLayer.consumerInsights.preferredPrice + ''
                  })
                }
              : { consumerInsights: undefined })
          })
        )
      } catch (e) {
        console.error('gtm push datalayer error', e)
      }
    },
    firstPageReadyFired ? 1000 : 0,
    dataLayer
  )
  firstPageReadyFired = true
}

function getVehiclePageData(dataLayer) {
  const queryParams = QueryUtils.getQueryParametersFromUrl()
  return trimObject({
    bodyStyle: dataLayer.vehicle.bodyStyle,
    catalog: dataLayer.pageInfo.experience,
    category: dataLayer.vehicle.category,
    chromeStyleId: dataLayer.vehicle.chromeStyleId,
    clickType: dataLayer.vehicle.clickType,
    customerType: dataLayer.vehicle.customerType,
    dealerPriorityType: dataLayer.vehicle.dealerPriorityType,
    dealershipId: dataLayer.offer.dealerId && dataLayer.offer.dealerId + '',
    driveTrain: dataLayer.vehicle.drivetrain,
    engineType: dataLayer.vehicle.engineType,
    entry: queryParams['v-entry'] ?? dataLayer.vehicle.entry,
    exteriorColor: dataLayer.vehicle.color,
    fuelEconomy: dataLayer.vehicle.fuelCategory,
    fuelType: dataLayer.vehicle.fuelType,
    makeId: dataLayer.vehicle.makeId && dataLayer.vehicle.makeId + '',
    makeName: dataLayer.vehicle.makeName,
    mileage: dataLayer.vehicle.mileage && dataLayer.vehicle.mileage + '',
    modelId: dataLayer.vehicle.modelId && dataLayer.vehicle.modelId + '',
    modelName: dataLayer.vehicle.modelName,
    price: dataLayer.vehicle.price && dataLayer.vehicle.price + '',
    transmission: dataLayer.vehicle.transmission,
    trimId: dataLayer.vehicle.trimId && dataLayer.vehicle.trimId + '',
    trimName: dataLayer.vehicle.trimName,
    type: dataLayer.vehicle.type,
    vehicleId: dataLayer.vehicle.id && dataLayer.vehicle.id + '',
    vin: dataLayer.vehicle.vin,
    year: dataLayer.vehicle.yearId && dataLayer.vehicle.yearId + ''
  })
}

function trimObject(obj) {
  const newObj = { ...obj }
  Object.keys(newObj).forEach(key => {
    if (newObj[key] === '' || !newObj[key]) {
      delete newObj[key]
    }
  })
  return newObj
}

function getPageInfo(pageInfo, offer) {
  switch (pageInfo.detailPageName) {
    case 'timbuybkhome_selltrade':
      if (pageInfo.linkName === 'timbuybkhome_selltrade_vinscan_open') {
        // B
        return {
          pageType: 'ico_home',
          detailPageName: 'ico_vinscan_open'
        }
      }
      if (offer && offer.offerId) {
        return {
          pageType: 'ico_thank',
          detailPageName: 'ico_thank'
        }
      }
      // else
      // A
      return {
        pageType: 'ico_home',
        detailPageName: 'ico_home'
      }
    case 'timbuybkvehdetails_selltrade' || 'ico_vehdetails': // C
      return {
        pageType: 'ico_vehdetails',
        detailPageName: 'ico_vehdetails'
      }
    case 'timbuybkopt_selltrade':
      return {}
    case 'timbuybkaftmkt_selltrade': // E
      return {
        pageType: 'ico_aft-mkt',
        detailPageName: 'ico_aft-mkt'
      }
    case 'timbuybkvehhist_selltrade': // D ..
      return {
        pageType: 'ico_vehhist',
        detailPageName: 'ico_vehhist'
      }
    case 'timbuybkcondquiz_selltrade_img': // F
      return {
        pageType: 'ico_condition',
        detailPageName: 'ico_condition_img'
      }
    case 'timbuybkcondquiz_selltrade_ext': // G
      return {
        pageType: 'ico_condition',
        detailPageName: 'ico_condition_ext'
      }
    case 'timbuybkcondquiz_selltrade_int': // H
      return {
        pageType: 'ico_condition',
        detailPageName: 'ico_condition_int'
      }
    case 'timbuybkcondquiz_selltrade_mech': // K
      return {
        pageType: 'ico_condition',
        detailPageName: 'ico_condition_mech'
      }
    case 'timbuybkcontact_selltrade': // L
      return {
        pageType: 'ico_contact',
        detailPageName: 'ico_contact'
      }
    case 'timbuybkresbmt_selltrade':
      return {
        pageType: 'ico_edit',
        detailPageName: 'ico_edit'
      }
    case 'timbuybkload_selltrade': // M
      return {
        pageType: 'ico_load',
        detailPageName: 'ico_load'
      }
    case 'timbuybkthank_selltrade': // N
      return {
        pageType: 'ico_thank',
        detailPageName: 'ico_thank'
      }
    default:
      return {}
  }
}

let firstContinueFired = false
let continueErrorPreventNext = false
const if_continue = dataLayer => {
  const cloneDataLayer = JSON.parse(JSON.stringify(dataLayer))
  try {
    setTimeout(
      cdl => {
        const dtlayer = {
          event: 'analytics_event',
          eventElement: `ico-${getExperience(cdl)}`,
          eventNonInteractive: false,
          ...getEventRest(cdl)
        }
        if (dtlayer.eventAction) {
          if (continueErrorPreventNext) {
            if (!dtlayer.eventResult === 'cta::continue') {
              window.dataLayer.push(dtlayer)
            }
          } else {
            window.dataLayer.push(dtlayer)
          }
          continueErrorPreventNext = false
        }
        if (dtlayer.eventResult === 'cta::continue_error::error') {
          continueErrorPreventNext = true
        }
      },
      firstContinueFired ? 0 : 200,
      cloneDataLayer
    )
    firstContinueFired = true
  } catch (error) {
    console.log('error when push window.dataLayer', error)
  }
}

// custom events for ATC Heading & Footer only
const fireCustomEvent = (event, isHeader) => {
  const element = event.currentTarget
  let qaid = element.attributes['data-qaid'] && element.attributes['data-qaid'].value
  const link = element.text ? element.text.replace(new RegExp(' ', 'g'), '-').toLowerCase() : ''
  if (link === 'sign-in') qaid = 'signin'
  const findAffiliatesIdx = [
    'find-classic-&-exotic-cars-for-sale',
    'find-motorcycles-for-sale',
    'find-rvs-for-sale',
    'find-cars-for-bad-credit-buyers',
    'find-cars-for-sale-in-australia',
    'visitor-agreement',
    'privacy-statement',
    'accessibility-statement'
  ].indexOf(link)
  if (findAffiliatesIdx > -1) {
    qaid = 'affiliates-' + findAffiliatesIdx
  }

  const whitelist = [
    {
      qaid: 'lnk-atc-logo',
      link: 'homepage',
      destinationPageType: 'homepage'
    },
    {
      qaid: 'lnk-fyc-used',
      link: 'used-cars',
      destinationPageType: 'slp_used'
    },
    {
      qaid: 'lnk-fyc-new',
      link: 'new-cars',
      destinationPageType: 'slp_new'
    },
    {
      qaid: 'lnk-syc',
      link: 'sell-my-car',
      destinationPageType: 'syc-or-ico'
    },
    {
      qaid: 'lnk-tim',
      link: 'get-a-kelly-blue-book-instance-cash-offer',
      destinationPageType: 'global-nav-header'
    },
    {
      qaid: 'lnk-kbb-tim',
      link: 'get-a-kelly-blue-book-instance-cash-offer',
      destinationPageType: 'global-nav-header'
    },
    ...[
      { qaid: 'lnk-car_dl', link: 'car-deals' },
      { qaid: 'lnk-truck_dl', link: 'trunk-deals' },
      { qaid: 'lnk-suv_dl', link: 'suv-deals' },
      { qaid: 'lnk-bst_car', link: 'best-cars' },
      { qaid: 'lnk-bco-hdr', link: 'buy-cars-online' },
      { qaid: 'lnk-cr', link: 'research-information' },
      { qaid: 'lnk-lt-art', link: 'lLatest-articles' },
      { qaid: 'lnk-nw-fut-mdl', link: 'new-feature-model' },
      { qaid: 'lnk-exp-spec-mdl', link: 'explore-specific-models' },
      { qaid: 'lnk-car-rvw', link: 'car-reviews' },
      { qaid: 'lnk-buy-car', link: 'how-to-buy-a-car' },
      { qaid: 'lnk-mnth-pmt-calc', link: 'car-payment-calculator' },
      { qaid: 'lnk-afd-calc', link: 'affordability-calculator' },
      { qaid: 'lnk-car-trd-tips', link: 'car-trade-in-tips' },
      { qaid: 'lnk-buy-usd-car', link: 'buying-a-used-car' }
    ].map(item => ({ ...item, destinationPageType: 'articles_' + item.link })),

    { qaid: 'lnk-gco', link: 'sponsoredget-a-free-insurance-quote-from-geico' },
    { qaid: 'lnk-loan', link: 'sponsoredpre-qualify-for-a-car-loan-with-no-credit-score-impact' },
    { qaid: 'lnk-fyd', link: 'find-local-dealers', destinationPageType: 'srp_dealer' },
    { qaid: 'signin', link: 'sign-in', destinationPageType: 'my_sign_in' },
    { qaid: 'lnk-car-res-rvw', link: 'sponsoredpre-qualify-for-a-car-loan-with-no-credit-score-impact' }
  ]
    .map(item => ({ ...item, location: 'header' }))
    .concat([
      {
        qaid: 'lnk-new-cars',
        link: 'new-cars',
        destinationPageType: 'slp_new'
      },
      {
        qaid: 'lnk-used-cars',
        link: 'used-cars',
        destinationPageType: 'slp_used'
      },
      {
        qaid: 'lnk-certified-cars',
        link: 'certified-cars',
        destinationPageType: 'slp_cpo'
      },
      {
        qaid: 'lnk-browse-cars',
        link: 'cars-for-sale',
        destinationPageType: 'vdp'
      },
      {
        qaid: 'lnk-car-deals',
        link: 'car-deals',
        destinationPageType: 'articles_car-deals'
      },
      {
        qaid: 'lnk-car-dealers',
        link: 'car-dealers',
        destinationPageType: 'srp_dealer'
      },
      {
        qaid: 'lnk-sell-car',
        link: 'sell-a-car',
        destinationPageType: 'syc-or-ico'
      },
      {
        qaid: 'lnk-trade-car',
        link: 'trade-in-a-car',
        destinationPageType: 'global-nav-footer'
      },
      {
        qaid: 'lnk-car-research',
        link: 'car-research',
        destinationPageType: 'articles_research'
      },
      {
        qaid: 'lnk-car-model-information',
        link: 'car-model-information',
        destinationPageType: 'slp_shop'
      },
      {
        qaid: 'lnk-tradeIn-values-car-pricing',
        link: 'trade-in-values-and-car-pricing',
        destinationPageType: 'eval_syc'
      },
      {
        qaid: 'lnk-bco-ftr',
        link: 'buy-cars-online',
        destinationPageType: 'buy-online-help'
      },
      {
        qaid: 'car-sbscr-srvs',
        link: 'car-subscription-services',
        destinationPageType: 'car-subst-serv'
      },
      {
        qaid: 'lnk-voice-search',
        link: 'find-cars-using-your-smart-speaker',
        destinationPageType: 'voice-srch-help'
      },
      {
        qaid: 'lnk-comp-info',
        link: 'company-information',
        destinationPageType: 'about-company' // not in the file https://coxautoinc.sharepoint.com/:x:/s/ConsumerPortfolioAnalyticsTagging/EV98p9NStjhDma-8xUDcUz8Bt4I8k1TrFUcXmTUUywKshg?e=fwStqH
      },
      {
        qaid: 'lnk-corporate-information',
        link: 'corporate-information',
        destinationPageType: 'about-corporate' // not in the file https://coxautoinc.sharepoint.com/:x:/s/ConsumerPortfolioAnalyticsTagging/EV98p9NStjhDma-8xUDcUz8Bt4I8k1TrFUcXmTUUywKshg?e=fwStqH
      },
      {
        qaid: 'lnk-jobs-autotrader',
        link: 'jobs-at-autotrader',
        destinationPageType: 'jobs_at_autotrader'
      },
      {
        qaid: 'lnk-become-autotrader-dealer',
        link: 'become-an-autotrader-dealer',
        destinationPageType: 'become-atc-dealer'
      },
      {
        qaid: 'lnk-press-room',
        link: 'press-room',
        destinationPageType: 'press-room'
      },
      {
        qaid: 'lnk-site-map',
        link: 'site-map',
        destinationPageType: 'site-map'
      },
      {
        qaid: 'lnk-contact-us',
        link: 'contact-us',
        destinationPageType: 'contact-us'
      },
      {
        qaid: 'lnk-help',
        link: 'help',
        destinationPageType: 'help' // not in the file https://coxautoinc.sharepoint.com/:x:/s/ConsumerPortfolioAnalyticsTagging/EV98p9NStjhDma-8xUDcUz8Bt4I8k1TrFUcXmTUUywKshg?e=fwStqH
      },
      {
        qaid: 'lnk-dt-sell-my-data',
        link: 'do-not-sell-my-data',
        destinationPageType: 'privacy-request'
      },
      {
        qaid: 'lnk-fraud-awareness',
        link: 'fraud-awareness',
        destinationPageType: 'fraud-awareness' // not in the file https://coxautoinc.sharepoint.com/:x:/s/ConsumerPortfolioAnalyticsTagging/EV98p9NStjhDma-8xUDcUz8Bt4I8k1TrFUcXmTUUywKshg?e=fwStqH
      },
      {
        qaid: 'affiliates-0',
        link: 'find-classic-&-exotic-cars-for-sale',
        destinationPageType: 'affiliates-find-classic-exotic' // not in the file https://coxautoinc.sharepoint.com/:x:/s/ConsumerPortfolioAnalyticsTagging/EV98p9NStjhDma-8xUDcUz8Bt4I8k1TrFUcXmTUUywKshg?e=fwStqH
      },
      {
        qaid: 'affiliates-1',
        link: 'find-motorcycles-for-sale',
        destinationPageType: 'affiliates-motorcycles-for-sale' // not in the file https://coxautoinc.sharepoint.com/:x:/s/ConsumerPortfolioAnalyticsTagging/EV98p9NStjhDma-8xUDcUz8Bt4I8k1TrFUcXmTUUywKshg?e=fwStqH
      },
      {
        qaid: 'affiliates-2',
        link: 'find-rvs-for-sale',
        destinationPageType: 'affiliates-find-rvs-for-sale' // not in the file https://coxautoinc.sharepoint.com/:x:/s/ConsumerPortfolioAnalyticsTagging/EV98p9NStjhDma-8xUDcUz8Bt4I8k1TrFUcXmTUUywKshg?e=fwStqH
      },
      {
        qaid: 'affiliates-3',
        link: 'find-cars-for-bad-credit-buyers',
        destinationPageType: 'affiliates-find-cars-for-bad-credit-buyers' // not in the file https://coxautoinc.sharepoint.com/:x:/s/ConsumerPortfolioAnalyticsTagging/EV98p9NStjhDma-8xUDcUz8Bt4I8k1TrFUcXmTUUywKshg?e=fwStqH
      },
      {
        qaid: 'affiliates-4',
        link: 'find-cars-for-sale-in-australia',
        destinationPageType: 'affiliates-find-cars-for-sale-in-australia' // not in the file https://coxautoinc.sharepoint.com/:x:/s/ConsumerPortfolioAnalyticsTagging/EV98p9NStjhDma-8xUDcUz8Bt4I8k1TrFUcXmTUUywKshg?e=fwStqH
      },
      {
        qaid: 'affiliates-5',
        link: 'visitor-agreement',
        destinationPageType: 'visitor-agreement'
      },
      {
        qaid: 'affiliates-6',
        link: 'privacy-statement',
        destinationPageType: 'privacy-statement'
      },
      {
        qaid: 'affiliates-7',
        link: 'accessibility-statement',
        destinationPageType: 'accessibility-statement'
      }
    ])

  // validate right element
  let isValid = false
  for (var i = 0; i < whitelist.length; i++) {
    if (whitelist[i].qaid === qaid) {
      isValid = true
      break
    }
  }
  if (!isValid) return

  function getEventResult() {
    // 3a
    if (qaid === 'lnk-gco') {
      return 'finance::capital-one::featured-partner::car-loans::get-pre-qualified'
    }
    // 3b
    if (qaid === 'lnk-loan') {
      return 'finance::capital-one::sponsored::pre-qualify-for-a-car-loan-with-no-credit-score-impact::global-header'
    }
    // 3b impression
    if (qaid === 'lnk-car-res-rvw') {
      return 'finance::capital-one::sponsored::pre-qualify-for-a-car-loan-with-no-credit-score-impact::global-header'
    }
    const typeOfLink = 'text-link'
    const destinationPageType = (() => {
      return whitelist.find(i => i.qaid === qaid).destinationPageType
    })()

    const link = (() => {
      if (qaid === 'lnk-atc-logo') return 'homepage'
      return whitelist.find(i => i.qaid === qaid).link
    })()
    return [typeOfLink, destinationPageType, link].join('::')
  }
  const eventNonInteractiveCheck = qaid === 'lnk-car-res-rvw' ? { eventNonInteractive: false } : {}
  const dtlayer = {
    event: 'analytics_event',
    eventElement: isHeader ? 'global-nav-header' : 'global-nav-footer',
    eventAction: qaid === 'lnk-car-res-rvw' ? actions.impression : actions.click,
    eventResult: getEventResult(),
    eventData: {},
    ...eventNonInteractiveCheck
  }
  window.dataLayer.push(dtlayer)
}

export { if_pageReady, if_continue, fireCustomEvent }

function getExperience(dataLayer) {
  return dataLayer.pageInfo.experience
}

const actions = {
  click: 'click',
  submit: 'submit',
  impression: 'impression',
  view: 'view'
}

function getEventRest(dataLayer) {
  const pageInfo = dataLayer.pageInfo
  const linkName = pageInfo.linkName

  const eventResultMap = {
    ico_mods_stereo: 'ico_mods_stereo',
    'ico_mods_wheels-tires': 'ico_mods_wheels-tires',
    ico_mods_suspension: 'ico_mods_suspension',
    ico_mods_performance: 'ico_mods_performance',
    ico_mods_exhaust: 'ico_mods_exhaust',
    ico_mods: 'ico_mods'
  }

  const impressionEventResult = ['ico_mods']

  if (linkName === eventResultMap[linkName] && typeof linkName !== 'undefined') {
    if (dataLayer.impressions) {
      return {
        eventAction: impressionEventResult.includes(linkName) ? actions.impression : actions.click,
        eventResult: eventResultMap[linkName],
        eventData: {
          vehicle: getVehiclePageData(window.ICO.dataLayer)
        }
      }
    }
  }

  if (linkName === 'cta::go-ineligible::listedvin') {
    return {
      eventAction: actions.click,
      eventResult: 'cta::go-ineligible::listedvin',
      eventData: {
        vehicle: {
          entry: dataLayer.vehicle.entry
        }
      }
    }
  }

  if (linkName === 'continue') {
    // G6, C1, E1, D1, H3, K1
    const impressions = dataLayer.impressions?.filter(i => i)
    if (impressions?.length > 0 && !impressions?.includes('amQ')) {
      const respFields = impressions.map(p => (p.includes('wheels_tires') ? 'wheels_tires' : p.split('_')[0])).join('::')
      const respValues = impressions.map(p => (p.includes('wheels_tires') ? p.split('_')[2] : p.split('_')[1])).join('::')
      return {
        eventAction: actions.click,
        eventResult: 'cta::continue',
        eventData: {
          ico: {
            responseFields: respFields,
            responseValues: respValues
          },
          vehicle: getVehiclePageData(window.ICO.dataLayer)
        }
      }
    }
  }
  if (linkName) {
    if (linkName.startsWith('continue_timbuybkhome_selltrade_')) {
      // #A1 - Landing Page Go error - click
      if (linkName.includes('_error')) {
        return {
          eventAction: actions.click,
          eventResult: 'cta::go-error::' + linkName.replace('continue_timbuybkhome_selltrade_', ''),
          eventData: {
            vehicle: {
              entry: dataLayer.vehicle.entry
            }
          }
        }
      } else if (linkName.includes('_ineligible')) {
        let formattedLinkName = linkName.replace('continue_timbuybkhome_selltrade_vin_ineligible_', '')
        if (formattedLinkName.includes('_ineligible')) {
          formattedLinkName = formattedLinkName.replace('_ineligible_', '|')
        }
        return {
          eventAction: actions.click,
          eventResult: 'cta::go-ineligible::' + formattedLinkName,
          eventData: {
            vehicle: {
              entry: dataLayer.vehicle.entry
            }
          }
        }
      } else if (linkName.includes('_mm')) {
        // A7 first time search
        return {
          eventAction: actions.click,
          eventResult: 'cta::go::ymm_manual',
          eventData: {
            vehicle: {
              entry: dataLayer.vehicle.entry
            }
          }
        }
      } else {
        return {
          eventAction: actions.click, // #A2 - Landing Page Go - click
          eventResult: 'cta::go',
          eventData: {
            vehicle: {
              entry: dataLayer.vehicle.entry
            }
          }
        }
      }
    } else if (linkName.startsWith('button::addphoto')) {
      // F1, F2, F3
      //Upload success
      if (linkName.startsWith('button::addphoto_success::')) {
        return {
          eventAction: actions.click,
          eventResult: 'button::addphoto_success::'
        }
      }
      //Upload failed
      if (linkName.startsWith('button::addphoto_fail::')) {
        return {
          eventAction: actions.click,
          eventResult: 'button::addphoto_error::'
        }
      }
    }
    //Delete Click
    else if (linkName.startsWith('cta::addphoto_delete')) {
      return {
        eventAction: actions.click,
        eventResult: 'cta::addphoto_delete'
      }
    }
    //See Photo Guidelines Click
    else if (linkName.startsWith('text-link::see-photo-guidelines')) {
      return {
        eventAction: actions.click,
        eventResult: 'text-link::see-photo-guidelines'
      }
    } else if (linkName.startsWith('Req_Appt_')) {
      // N3
      return {
        eventAction: actions.click,
        eventResult: 'button::request-appointment::dealer'
      }
    } else if (linkName.startsWith('tel_')) {
      // N4
      return {
        eventAction: actions.click,
        eventResult: 'text-link::phone',
        eventData: {
          vehicle: getVehiclePageData(window.ICO.dataLayer)
        }
      }
    } else if (linkName.startsWith('sitelink_dealerlink_')) {
      // N5
      return {
        eventAction: actions.click,
        eventResult: 'text-link::sitelink',
        eventData: {
          vehicle: getVehiclePageData(window.ICO.dataLayer)
        }
      }
    } else if (linkName.startsWith('continue_error_')) {
      // P1
      // Check not input customer information
      if (linkName.endsWith('_tiused') || linkName.endsWith('_tinew') || linkName.endsWith('_ticpo')) {
        return {
          eventAction: actions.click,
          eventResult: 'cta::continue_error::' + linkName.replace('continue_error_', '')
        }
      }
      if (linkName.endsWith('_ineligible')) {
        return {
          eventAction: actions.impression,
          eventResult: 'cta::continue_error::' + linkName.replace('continue_error_', '')
        }
      }
    } else if (linkName.startsWith('contact_infor_createacct')) {
      // L1
      return {
        eventAction: actions.click,
        eventResult: 'cta::continue::create-acct'
      }
    } else if (['front', 'driver', 'rear', 'passenger', 'windows'].map(ext => 'sm_' + ext).includes(linkName)) {
      // G1, G2, G3, G4, G5
      return {
        eventAction: actions.click,
        eventResult: `button::subnav::${linkName.replace('sm_', '')}`
      }
    } else if (['seats_carpet_headliner', 'dashboard_lights'].map(ext => 'sm_' + ext).includes(linkName)) {
      // H1, H2
      return {
        eventAction: actions.click,
        eventResult: `button::subnav::${linkName.replace('sm_', '')}`
      }
    } else if (linkName.startsWith('next_step') || linkName.startsWith('continue_modal')) {
      // P2
      console.log('cta::continue : P2', linkName)
      return {
        eventAction: actions.click,
        eventResult: 'cta::continue',
        eventData: {
          vehicle: getVehiclePageData(window.ICO.dataLayer)
        }
      }
    } else if (linkName.startsWith('pic1_')) {
      // F4 -> E6
      let pics = linkName.split(',')
      console.log('cta::continue : F4 -> E6', linkName)
      return {
        eventAction: actions.click,
        eventResult: 'cta::continue',
        eventData: {
          ico: {
            responseFields: pics.map(p => p.split('_')[0]).join('::'),
            responseValues: pics.map(p => p.split('_')[1]).join('::')
          },
          vehicle: getVehiclePageData(window.ICO.dataLayer)
        }
      }
    } else if (linkName.startsWith('cta::start-my-offer-error::') || linkName.startsWith('cta::start-my-offer-ineligible::')) {
      // A1 - Landing Page Start My Offer Error - Click
      // A11 - Landing Page Go Error - Ineligible Reasons - Click
      return {
        eventAction: actions.click,
        eventResult: linkName
      }
    } else {
      switch (linkName) {
        case 'cta::start-my-offer': // #A2 - Start My Offer - Click
        case 'text-link::whereismyvin': // #A3 Where is My VIN - Click
        case 'cta::mileage::next': // #A4 Mileage Continue - Click
        case 'cta::style::next': // #A5 Style - Milage - Continue - Click
        case 'cta::go::ymm_manual': // #A6 Manual Enter VIN CTA Click
        case 'cta::start-my-offer::step-by-step': // #A7 - Start My Offer - Step by Step - Click
        case 'cta::start-my-offer::faq': // #A8 - Start My Offer - FAQ - Click
        case 'cta::proceed-without-instant-cash-offer': // #A9 - Proceed without Instant Cash Offer - Click
        case 'cta::start-my-offer-scan': // #A10 - Start My Offer - Scan - Click
        case 'cta::start-my-offer::video': // M4 Start My Offer - Click
          return {
            eventAction: actions.click,
            eventResult: linkName
          }
        case 'whereismyvin_lnk': // #A3 - Where is my VIN - click
          return {
            eventAction: actions.click,
            eventResult: 'text-link::' + linkName.replace('_lnk', '')
          }
        case 'timbuybkhome_selltrade_mileageselect': // #A4 - Milage continue - click
          return {
            eventAction: actions.click,
            eventResult: 'cta::mileage::next'
          }
        case 'timbuybkhome_selltrade_styleselect': // #A6 - Style - Milage - continue - click
          return {
            eventAction: actions.click,
            eventResult: 'cta::style::next'
          }
        case 'timbuybkhome_selltrade_vinscan_success': // B1
          return {
            eventAction: actions.click,
            eventResult: 'button::vin-scan::success'
          }
        case 'timbuybkhome_selltrade_vinscan_error': // B1
          return {
            eventAction: actions.click,
            eventResult: 'button::vin-scan::error'
          }
        case 'RequestAppt_Top': // N1
          return {
            eventAction: actions.click,
            eventResult: 'button::request-appointment::top',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'button::request-appointment::top': // N1
          return {
            eventAction: actions.click,
            eventResult: 'button::request-appointment::top',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'button::request-appointment::dealer': // N1
          return {
            eventAction: actions.click,
            eventResult: 'button::request-appointment::dealer',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'vehicle-history-report': // K10
        case 'vehicle-history-report::autocheck': // K10
          return {
            eventAction: actions.click,
            eventResult: 'vehicle-history-report::autocheck',
            eventElement: 'partner',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'text-link::more-info::map': {
          return {
            eventAction: actions.click,
            eventResult: 'text-link::more-info::map',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        }
        case 'text-link::get-directions': {
          return {
            eventAction: actions.click,
            eventResult: 'text-link::get-directions',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        }
        case 'text-link::phone': // N1
          return {
            eventAction: actions.click,
            eventResult: 'text-link::phone',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'text-link::sitelink': // N1
          return {
            eventAction: actions.click,
            eventResult: 'text-link::sitelink',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'text-link::see_more_dealers': // N1
          return {
            eventAction: actions.click,
            eventResult: 'text-link::see_more_dealers',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'submit::ico::request-appointment': // N1
          return {
            eventAction: actions.submit,
            eventResult: 'submit::ico::request-appointment',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'see_more_dealers': // N2
          return {
            eventAction: actions.click,
            eventResult: 'text-link::' + linkName,
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'submit_request_appointment': // N6
          return {
            eventAction: actions.submit,
            eventResult: 'submit::ico::request-appointment',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'continue_error': // P1
          return {
            eventAction: actions.click,
            eventResult: 'cta::continue_error::error',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'summary_submit_offer': // L2
          const offer = window.ICO.dataLayer.offer
          const replacementVehicle = window.ICO.dataLayer.replacementVehicle
          const { minYear, maxYear, makeId, make, modelId, model, trimId, trimName, types } = replacementVehicle
          const { offerId, optIn } = offer

          return {
            eventAction: actions.submit,
            eventResult: 'submit::ico::get-my-offer',
            eventData: {
              ico: {
                optionToSell: optIn,
                offerId: offerId
              },
              vehicle: getVehiclePageData(window.ICO.dataLayer),
              voi: {
                entry: 'ymm',
                catalog: window.ICO.dataLayer.pageInfo.experience,
                year: minYear && maxYear && `${minYear}-${maxYear}`,
                makeId: makeId,
                makeName: make,
                modelId: modelId,
                modelName: model,
                trimId: trimId,
                trimName: trimName,
                condition: types ? types.join('::') : undefined
              }
            }
          }

        case 'video_start':
          return {
            eventAction: actions.click,
            eventResult: 'video::start'
          }
        case 'video_milestones_25%':
        case 'video_milestones_50%':
        case 'video_milestones_75%':
          const percentage = linkName.split('_').at(-1)
          return {
            eventAction: actions.view,
            eventResult: `video::` + percentage
          }
        case 'video_complete':
          return {
            eventAction: actions.view,
            eventResult: 'video::complete'
          }

        case 'back': // P3
          return {
            eventAction: actions.click,
            eventResult: 'cta::back',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'sm_return_to_questionnaire_btn': // P5
          return {
            eventAction: actions.click,
            eventResult: 'cta::modal::return',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'sm_skip_to_next_steps_modal_btn': // P6
          return {
            eventAction: actions.click,
            eventResult: 'cta::modal::skip',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'resubmit_btn': // O1
          return {
            eventAction: actions.submit,
            eventResult: 'submit::ico::offer-expired',
            eventData: {
              offerId: window.ICO.dataLayer.offer.offerId
            }
          }
        case 'image::vdp::inventory-partial':
        case 'image::vdp::inventory-exact':
          return {
            eventAction: actions.click,
            eventResult: linkName,
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'button::subnav::front':
          return {
            eventAction: actions.click,
            eventResult: 'button::subnav::front',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'button::subnav::driver':
          return {
            eventAction: actions.click,
            eventResult: 'button::subnav::driver',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'button::subnav::rear':
          return {
            eventAction: actions.click,
            eventResult: 'button::subnav::rear',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'button::subnav::passenger':
          return {
            eventAction: actions.click,
            eventResult: 'button::subnav::passenger'
          }
        case 'button::subnav::windows':
          return {
            eventAction: actions.click,
            eventResult: 'button::subnav::windows',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'button::subnav::dashboard_lights':
          return {
            eventAction: actions.click,
            eventResult: 'button::subnav::dashboard_lights'
          }
        case 'button::subnav::seats_carpet_headliner':
          return {
            eventAction: actions.click,
            eventResult: 'button::subnav::seats_carpet_headliner'
          }
        // Vehicle Details Integration c1-c3 analytics events
        case 'text-link::ineligible::place-an-ad':
          return {
            eventAction: actions.click,
            eventResult: 'text-link::ineligible::place-an-ad',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'text-link::ineligible::get-my-cars-value':
          return {
            eventAction: actions.click,
            eventResult: 'text-link::ineligible::get-my-cars-value',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        case 'ico_vehdetails':
          return {
            eventAction: actions.impression,
            eventResult: 'ico_vehdetails',
            eventData: {
              vehicle: getVehiclePageData(window.ICO.dataLayer)
            }
          }
        default:
          return {}
      }
    }
  }
}

function getOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone'
  }

  if (/android/i.test(userAgent)) {
    return 'Android'
  }

  // iOS detection
  if ((/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return 'iOS'
  }

  return 'web'
}
